import * as v0 from "@aidkitorg/types/lib/survey";
import { Icon, Modal } from "@aidkitorg/component-library";
import { useLocalizedStrings } from "../../../Localization";
import { stripHtmlAndMarkdown } from "@aidkitorg/types/lib/utils/textSanitizer";
import { ConnectionModalProvider, useConnectionModal } from "./ConnectionModalContext";
import { ConnectionModalContents } from "./ConnectionModalContents";

interface ConnectionModalProps extends ConnectionModalInnerProps {
  component: v0.DeckVerification;
  onSubmit: (connectionToken: string) => void;
  onExit: () => void;
}

export function ConnectionModal({
  component,
  open,
  onSubmit,
  onExit,
}: ConnectionModalProps) {
  return <ConnectionModalProvider
    component={component}
    onSubmit={onSubmit}
    onExit={onExit}
  >
    <ConnectionModalInner open={open} />
  </ConnectionModalProvider>;
}

interface ConnectionModalInnerProps {
  open: boolean;
}

function ConnectionModalInner({
  open,
}: ConnectionModalInnerProps) {
  const L = useLocalizedStrings();
  const { getLocalizedString, onExit } = useConnectionModal();

  const headerText = stripHtmlAndMarkdown(getLocalizedString("header", "header"));

  return <Modal
    open={open}
    title={headerText}
    preventBackdropClick
    onClose={onExit}
  >
    <div className="max-h-[75vh]">
      <div className="absolute right-0 top-0 pr-4 pt-4 rtl:left-0 rtl:right-auto rtl:top-0 rtl:pl-4 rtl:pr-0 rtl:pt-4">
        <button
          type="button"
          onClick={onExit}
          className="rounded-md bg-white text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          <span className="sr-only">{L.component_library.modal.close}</span>
          <Icon name="XMarkIcon" />
        </button>
      </div>

      <ConnectionModalContents />
    </div>
  </Modal>;
};
